/**
 * 戦闘力期待値編集の権限判定（ドメインルール）。
 *
 * 編集可能なのは次のいずれかを満たすユーザーのみ:
 * 1. cortex 管理者 (`admin` ロールを保持)
 * 2. `division === 'pi_div'` かつ `team_leader` ロールを保持
 * 3. `teamName === 'pi_pmot'` (PMO チームメンバー — 保持ロールを問わず全員)
 *
 * 複数ロール保持時は各条件を existential（`.includes()`）チェックする（優先順位ではない）。
 * frontend / backend 双方の SSOT。重複定義は禁止。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 戦闘力期待値編集の権限ルール (admin / pi_div+team_leader / pi_pmot)
 * @graph-connects none
 */
/** @graph-connects none */
export function canEditCombatPowerExpected(input) {
    const roles = input.portalRoles ?? [];
    if (roles.includes('admin'))
        return true;
    if (roles.includes('team_leader') && input.division === 'pi_div')
        return true;
    if (input.teamName === 'pi_pmot')
        return true;
    return false;
}
//# sourceMappingURL=edit-permission.js.map